export default __webpack_public_path__ + "6215618bd4c7efb1bde40798b60b50b2.png";